import { FC } from 'react'
import {
  Card as InternalCard,
  CardGridProps,
  CardMetaProps,
  CardProps,
  Grid,
  Meta,
} from './card'
import { Divider, DividerProps as CardDividerProps } from './divider'

interface CardType extends FC<CardProps> {
  Meta: typeof Meta
  Grid: typeof Grid
  Divider: typeof Divider
}

const Card = InternalCard as CardType
Card.Meta = Meta
Card.Grid = Grid
Card.Divider = Divider

export { Card }
export type { CardProps, CardMetaProps, CardGridProps, CardDividerProps }
